import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Typography } from '@mui/material'

import { useTranslation } from 'shared/hooks/useSafeTranslation'
import useStyle from 'shared/hooks/useStyle'

import styles from './StepPageLayout.styles'

const propTypes = {
    title: PropTypes.string.isRequired,
    isRequired: PropTypes.bool,
    isAnswered: PropTypes.bool.isRequired,
    isNested: PropTypes.bool,
    isSummaryView: PropTypes.bool,
    children: PropTypes.node.isRequired,
}

const StepPageLayout = ({
    title,
    isRequired = false,
    isAnswered,
    isNested = false,
    isSummaryView = false,
    children,
}) => {
    const classes = useStyle(styles)
    const { t } = useTranslation()

    const stateMessage = useMemo(() => {
        if (!isAnswered) {
            if (isRequired) { return 'TO_BE_ANSWERED' }
            return 'NOT_ANSWERED'
        }
        return 'COMPLETED'
    }, [
        isAnswered,
        isRequired,
    ])

    return (
        <div css={classes.main(isNested)}>
            <div css={classes.title(isRequired, isAnswered)}>
                <Typography
                    variant="h3"
                    css={classes.titleText}
                >
                    {title}
                </Typography>
                {isSummaryView && (
                    <Typography
                        variant="h5"
                        css={classes.stateText}
                    >
                        {t(stateMessage)}
                    </Typography>
                )}
            </div>
            <div css={classes.childborder(isRequired, isAnswered)}>
                {children}
            </div>
        </div>
    )
}

StepPageLayout.propTypes = propTypes

export default StepPageLayout
